import { useNavigate } from 'react-router-dom';
import { Mail, FileText } from '@/components/icons';
import { SectionHeader } from '@/components/ui/SectionHeader';
import delhiveryLogo from '@/assets/delhivery-logo.png';

const CONFIGS = [
  {
    id: 'email',
    title: 'Email Configuration',
    description: 'Set up SMTP to send invoices, RFQs, and purchase orders to customers and vendors automatically.',
    path: '/admin/configurations/email',
    color: 'from-blue-500 to-blue-700',
  },
  {
    id: 'whatsapp',
    title: 'WhatsApp Configuration',
    description: 'Connect via Meta Business API or scan QR code to send WhatsApp messages to customers and vendors.',
    path: '/admin/configurations/whatsapp',
    color: 'from-green-500 to-green-700',
  },
  {
    id: 'doc-templates',
    title: 'Email Templates',
    description: 'Set default email subjects, body text, and footer notes for Purchase Orders, RFQs, Invoices, and more.',
    path: '/admin/configurations/doc-templates',
    color: 'from-orange-500 to-orange-700',
  },
  {
    id: 'shopify',
    title: 'Shopify Integration',
    description: 'Connect the Shopify store, test the connection, sync the catalogue, and manage order & stock sync settings.',
    path: '/admin/configurations/shopify',
    color: 'from-emerald-500 to-emerald-700',
  },
  {
    id: 'delhivery',
    title: 'Delhivery Shipping',
    description: 'Set the API token, pickup location and environment, register the warehouse, and toggle dry-run for courier bookings.',
    path: '/admin/configurations/delhivery',
    color: 'from-red-500 to-red-700',
  },
];

export function ConfigurationsPage() {
  const navigate = useNavigate();

  return (
    <div>
      <SectionHeader
        title="Configurations"      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CONFIGS.map((cfg) => (
          <button
            key={cfg.id}
            onClick={() => navigate(cfg.path)}
            className="group text-left rounded-xl border border-[var(--border-color)] bg-[var(--card-bg)] p-5 hover:border-accent hover:shadow-lg transition-all"
          >
            <div className={`mb-4 inline-flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl shadow ${cfg.id === 'shopify' ? 'bg-white ring-1 ring-[var(--border-color)]' : cfg.id === 'delhivery' ? 'bg-black' : `bg-gradient-to-br ${cfg.color} text-white`}`}>
              {cfg.id === 'whatsapp' ? (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.524 3.655 1.435 5.161L2 22l4.949-1.412A9.953 9.953 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.95 7.95 0 01-4.055-1.107l-.29-.173-3.007.858.862-3.012-.19-.308A7.963 7.963 0 014 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"/>
                </svg>
              ) : cfg.id === 'email' ? (
                <Mail size={26} />
              ) : cfg.id === 'delhivery' ? (
                <img src={delhiveryLogo} alt="Delhivery" className="h-full w-full object-cover" />
              ) : cfg.id === 'shopify' ? (
                <svg width="26" height="30" viewBox="0 0 256 292" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill="#95BF47" d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.774 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"/>
                  <path fill="#5E8E3E" d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357z"/>
                  <path fill="#FFF" d="M135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338z"/>
                </svg>
              ) : (
                <FileText size={26} />
              )}
            </div>
            <div className="text-base font-extrabold text-[var(--text-primary)] group-hover:text-accent transition-colors">
              {cfg.title}
            </div>
            <div className="mt-1 text-xs text-[var(--text-muted)] leading-relaxed">
              {cfg.description}
            </div>
            <div className="mt-4 text-xs font-bold text-accent">
              Configure →
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
